import { useEffect } from "react";
import seo from "../../seo/pages.json";

function setMeta(selector, attr, value) {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement(selector.startsWith("link") ? "link" : "meta");
    const [, key, name] = selector.match(/\[(\w+(?::\w+)?)="([^"]+)"\]/);
    el.setAttribute(key, name);
    document.head.appendChild(el);
  }
  el.setAttribute(attr, value);
}

// Updates the page's title, description, canonical URL and social tags.
// The same values are written into each page's HTML at build time by
// scripts/seo-build.js, so search engines see them without running JavaScript.
function Seo({ title, description, path, noindex = false }) {
  useEffect(() => {
    const url = seo.siteUrl + (path === "/" ? "/" : path);
    document.title = title;
    setMeta('meta[name="description"]', "content", description);
    setMeta('link[rel="canonical"]', "href", url);
    setMeta('meta[property="og:title"]', "content", title);
    setMeta('meta[property="og:description"]', "content", description);
    setMeta('meta[property="og:url"]', "content", url);
    setMeta('meta[name="twitter:title"]', "content", title);
    setMeta('meta[name="twitter:description"]', "content", description);
    setMeta('meta[name="robots"]', "content", noindex ? "noindex" : "index, follow");
  }, [title, description, path, noindex]);
  return null;
}

// Seo for one of the fixed pages listed in seo/pages.json.
export function PageSeo({ path }) {
  const page = seo.pages[path];
  return <Seo title={page.title} description={page.description} path={path} />;
}

export default Seo;
